import AdminLogin from '../../views/Admin/Auth/Login';

const routes = [
    {path: '/admin/login', name: 'AdminLogin', component: AdminLogin, meta : { layout : 'default', requiresAuth : false, is_admin : true, title : 'Admin Login'}}
]

export default routes;